import { render } from "./SelectedCoulmnArticle.vue?vue&type=template&id=779ad92c"
import script from "./SelectedCoulmnArticle.vue?vue&type=script&lang=js"
export * from "./SelectedCoulmnArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__